// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","container":"Footer_container__bv16B","footerLinks":"Footer_footerLinks__NKkj1","logo":"Footer_logo__+SElo","link":"Footer_link__c7GbB"};